import React from 'react';
import { useAuth, useClerk } from '@clerk/clerk-react';
import AvatarMenu from './AvatarMenu';
import NotificationBell from './NotificationBell';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import { useAppContext } from '../context/AppContext';

const EnhancedNavbar: React.FC = () => {
  const { isSignedIn } = useAuth();
  const { openSignIn } = useClerk();
  const navigate = useNavigate();
  const { userRole } = useAppContext();

  const handleLogoClick = () => {
    if (!userRole) {
      navigate('/');
    } else if (userRole === 'sponsor') {
      navigate('/sponsor/dashboard');
    } else {
      navigate('/events');
    }
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200"
      style={{
        backgroundColor: 'rgba(248, 245, 242, 0.95)',
        backdropFilter: 'blur(10px)'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <button
              onClick={handleLogoClick}
              className="flex items-center hover:opacity-80 transition-opacity"
              aria-label="Go to home"
            >
              <img
                src={logo}
                alt="AI Builders Hackdays"
                className="h-10 w-auto"
              />
            </button>
          </div>

          {/* Right side - Notification Bell, Avatar Menu or Sign In */}
          <div className="flex items-center gap-2">
            {isSignedIn && <NotificationBell />}
            {isSignedIn ? (
              <AvatarMenu />
            ) : (
              <button
                onClick={() => openSignIn()}
                className="px-6 py-2 rounded-full font-semibold transition-all duration-300 hover:scale-105 text-sm"
                style={{
                  background: 'linear-gradient(135deg, #90D8D8 0%, #DABAEA 50%, #F87789 100%)',
                  color: '#363232',
                  fontFamily: 'Space Grotesk, sans-serif'
                }}
              >
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default EnhancedNavbar;
